import appConfig from "../../../src/app.config";
import Vue from "vue";

Vue.filter('points', function (value) {
    return parseFloat(value).toLocaleString(appConfig.locale, { style: 'decimal' })
})